import {BASIC_SET_WINDOW_SIZE} from "../../constants/store";

export const windowSize = (state = false, action) => {
  switch (action.type) {
    case BASIC_SET_WINDOW_SIZE:
      return action.payload;
    default:
      return state;
  }
};